import classNames from 'classnames'
import React from 'react'

import './MeasurLogo.scss'

const MeasurLogo = ({
  className,
  // isCollapsible hides the text on narrower screens
  isCollapsible,
  textColor = '#575756',
}: {
  className?: string
  isCollapsible?: boolean
  textColor?: string
}) => {
  const badge = (
    <svg
      className="measurLogo__badge"
      width="29"
      height="29"
      fill="none"
      viewBox="0 0 80 80"
    >
      <title>Measurlabs badge</title>
      <path
        d="M59.984 0H20.016C8.96 0 0 8.961 0 20.016v39.968C0 71.04 8.961 80 20.016 80h39.968C71.04 80 80 71.039 80 59.984V20.016C80 8.96 71.039 0 59.984 0Z"
        fill="#185EF2"
      />
      <path
        d="M14.384 54.234V20.116l25.62 15.112 16.032-8.361 9.58.018v32.999l-9.58-.018v-22.71L40.004 46.62l-16.04-9.453v22.718l-9.58-5.65Z"
        fill="#fff"
      />
    </svg>
  )

  const badgeAndText = (
    <svg
      className="measurLogo__full"
      viewBox="0 0 506.31 87.93"
      width="166"
      height="29"
    >
      <title>Measurlabs logo</title>
      <rect width="87.93" height="87.93" rx="22" fill="#185ef2" />
      <path
        fill="#fff"
        d="M15.81 59.61v-37.5l28.16 16.61 17.62-9.19 10.53.02v36.27l-10.53-.02V40.84l-17.62 10.4-17.63-10.39v24.97l-10.53-6.21z"
      />
      <path
        d="M164.91 22.11v43.67h-4.43V30.85l-17.16 29.38h-2.18L124 31v34.78h-4.43V22.11h3.81l19 32.38 18.72-32.38zm45.23 28.68h-27.37a11.7 11.7 0 003.92 8.21 13 13 0 009 3.15 14.18 14.18 0 005.59-1.09 12.28 12.28 0 004.42-3.21l2.49 2.87a14 14 0 01-5.44 4 18.49 18.49 0 01-7.19 1.36A18.14 18.14 0 01186.6 64a15.41 15.41 0 01-6.07-6 17 17 0 01-2.18-8.59 17.52 17.52 0 012.09-8.58 15.13 15.13 0 015.72-5.91 16 16 0 018.18-2.11 15.82 15.82 0 018.15 2.11 15 15 0 015.66 5.88 17.68 17.68 0 012 8.61zm-23.73-11.16a11.82 11.82 0 00-3.64 7.87H206a11.82 11.82 0 00-3.64-7.87 12 12 0 00-15.92 0zM245.8 36q3.42 3.21 3.42 9.49v20.29H245v-5.1a10.13 10.13 0 01-4.39 4 15.27 15.27 0 01-6.87 1.43q-5.47 0-8.71-2.61a9 9 0 01-.22-13.62q3-2.55 9.61-2.55h10.38v-2q0-4.23-2.36-6.44t-6.91-2.21a17.67 17.67 0 00-6 1 15 15 0 00-4.91 2.83l-2-3.3a17.71 17.71 0 016-3.26 23.16 23.16 0 017.38-1.13q6.38 0 9.8 3.18zm-5 24.88a10.24 10.24 0 004-4.94v-5.33h-10.26q-8.4 0-8.4 5.84a5.35 5.35 0 002.18 4.55 9.89 9.89 0 006.09 1.65 11.64 11.64 0 006.41-1.75zm26.34 4.06a16.34 16.34 0 01-5.69-2.89l2-3.48a16.67 16.67 0 005.16 2.64 20.38 20.38 0 006.47 1q4.49 0 6.63-1.4a4.45 4.45 0 002.14-4 3.54 3.54 0 00-1.18-2.83 7.89 7.89 0 00-3-1.56 43.37 43.37 0 00-4.79-1 54.81 54.81 0 01-6.4-1.42 9.36 9.36 0 01-4.14-2.64 7.34 7.34 0 01-1.71-5.16 8.09 8.09 0 013.42-6.72q3.42-2.61 9.52-2.61a24.74 24.74 0 016.35.84 17.3 17.3 0 015.22 2.21l-1.93 3.54a16.55 16.55 0 00-9.64-2.8q-4.23 0-6.37 1.49a4.59 4.59 0 00-2.15 3.85 3.87 3.87 0 001.21 3 7.43 7.43 0 003 1.65 50.86 50.86 0 005 1.09 55.39 55.39 0 016.28 1.49 9.3 9.3 0 014 2.55 7 7 0 011.68 5 7.91 7.91 0 01-3.58 6.82q-3.57 2.51-9.92 2.51a25.07 25.07 0 01-7.58-1.17zm63.17-31.87v32.71h-4.23v-6a12.08 12.08 0 01-4.79 4.64 14.37 14.37 0 01-7 1.64q-6.4 0-10.11-3.57T300.52 52V33h4.41v18.6c0 3.44.85 6.06 2.56 7.84s4.12 2.67 7.27 2.67a10.69 10.69 0 008.15-3.11q3-3.13 3-8.74V33.07zm24.96 1.43a15.73 15.73 0 017.62-1.68v4.29l-1.06-.06a10.44 10.44 0 00-8.09 3.17c-1.95 2.11-2.92 5.08-2.92 8.89v16.67h-4.42V33.07h4.23v6.4a10.72 10.72 0 014.64-4.97zm19.83-14.87h4.42v46.15h-4.42zM417.43 36q3.42 3.21 3.43 9.49v20.29h-4.23v-5.1a10.13 10.13 0 01-4.39 4 15.27 15.27 0 01-6.87 1.43q-5.47 0-8.71-2.61a9 9 0 01-.22-13.62q3-2.55 9.61-2.55h10.39v-2q0-4.23-2.36-6.44t-6.91-2.21a17.67 17.67 0 00-6 1 14.89 14.89 0 00-4.91 2.83l-2-3.3a17.52 17.52 0 016-3.26 23.16 23.16 0 017.34-1.15q6.4.02 9.83 3.2zm-5 24.88a10.24 10.24 0 004-4.94v-5.33h-10.25q-8.4 0-8.4 5.84A5.33 5.33 0 00400 61a9.89 9.89 0 006.09 1.65 11.64 11.64 0 006.37-1.75zm49.48-25.98a14.9 14.9 0 015.85 5.88 17.45 17.45 0 012.12 8.64 17.46 17.46 0 01-2.12 8.65 15.11 15.11 0 01-5.85 5.93 16.56 16.56 0 01-8.33 2.11 15.42 15.42 0 01-7.37-1.74 13.51 13.51 0 01-5.26-5v6.46h-4.23v-46.2h4.42v19.66a13.62 13.62 0 015.25-4.82 15.48 15.48 0 017.19-1.65 16.75 16.75 0 018.33 2.08zm-2.42 25.69a11.19 11.19 0 004.38-4.51 14.72 14.72 0 000-13.31 11.19 11.19 0 00-4.38-4.51 13 13 0 00-12.47 0 11.28 11.28 0 00-4.36 4.51 13.7 13.7 0 00-1.58 6.65 13.71 13.71 0 001.58 6.66 11.28 11.28 0 004.34 4.51 13 13 0 0012.47 0zm25.7 4.35a16.34 16.34 0 01-5.69-2.89l2-3.48a16.61 16.61 0 005.17 2.64 20.34 20.34 0 006.47 1q4.47 0 6.62-1.4a4.46 4.46 0 002.15-4 3.55 3.55 0 00-1.19-2.83 7.81 7.81 0 00-3-1.56 43.37 43.37 0 00-4.79-1 54.81 54.81 0 01-6.4-1.42 9.33 9.33 0 01-4.13-2.64 7.34 7.34 0 01-1.72-5.16 8.1 8.1 0 013.43-6.72q3.42-2.61 9.51-2.61a24.74 24.74 0 016.35.84 17.3 17.3 0 015.22 2.21l-1.93 3.54a16.55 16.55 0 00-9.64-2.8q-4.23 0-6.37 1.49A4.59 4.59 0 00485.1 42a3.9 3.9 0 001.21 3 7.43 7.43 0 003 1.65 50.86 50.86 0 005 1.09 55.39 55.39 0 016.28 1.49 9.3 9.3 0 014 2.55 7 7 0 011.68 5 7.91 7.91 0 01-3.58 6.82q-3.57 2.51-9.92 2.51a25.07 25.07 0 01-7.58-1.17z"
        fill={textColor}
      />
    </svg>
  )

  return (
    <div
      className={classNames(
        'measurLogo',
        { 'measurLogo--collapsible': isCollapsible },
        className,
      )}
    >
      {badge}
      {badgeAndText}
    </div>
  )
}

export default MeasurLogo
